import React, { Component } from "react";
import {
  Grid,
  Paper,
  Typography,
  TextField,
  withStyles,
} from "@material-ui/core";
import Navi_Buttons from "../../components/forms/navi_buttons";
import { withRouter } from "react-router-dom";
import Categories from "./filter_bar/categories";
import LoadingBar from "../../components/data/loading";
import ModelBox from "./display_boxes/fetched_models_box";
import Features from "./filter_bar/features";
import SearchInput from "./filter_bar/search";

const styles = {
  root: {
    flexGrow: 1,
    width: "100%",
    padding: 10,
  },
};

class Form_Modellen extends Component {
  CreateFilter() {
    var Filter = {};
    const Categories = [
      ["display", 20],
      ["modellen", true],
      ["pins", false],
      ["modellen_DINH_WG", true],
      ["modellen_DINH_NG", false],
      ["AllesKönner", false],
      ["videos", false],

      ["Fabrikant", 0],
      ["Type", 0],
    ];
    for (let i = 0; i < Categories.length; i++) {
      Filter[Categories[i][0]] = localStorage.getItem(Categories[i][0])
        ? JSON.parse(localStorage.getItem(Categories[i][0]))
        : Categories[i][1];
    }
    return Filter;
  }

  constructor(props) {
    super(props);
    this.state = {
      search: this.props.location.state
        ? this.props.location.state.search
        : localStorage.getItem("search")
        ? localStorage.getItem("search")
        : "",
      page: localStorage.getItem("page")
        ? localStorage.getItem("page")
        : this.props.match.params.page,
      fetched_models_array: [],
      max: 0,
      isLoading: true,
      filter: this.CreateFilter(),
    };
  }

  fetch_data(page) {
    let post_json = {
      search: this.state.search,
      sorteren: "ModelID",
      page: page,
      filter: this.state.filter,
      type: "search_query",
      auth: localStorage.getItem("auth"),
    };
    console.log(JSON.stringify(post_json));
    fetch("/api/fetch_data.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-form-urlencoded",
      },
      body: JSON.stringify(post_json),
    })
      .then((response) => response.json())
      .then((data) => {
        // console.log(data);
        this.setState({
          fetched_models_array: data.fetched_models_array,
          max: data.max_pages.total,
          isLoading: false,
        });
      })
      .catch(() =>
        this.setState({
          fetched_models_array: [],
          max: 0,
          isLoading: false,
        })
      );
  }

  componentDidMount() {
    this.fetch_data(this.props.match.params.page);
  }

  componentDidUpdate(prevProps, prevState) {
    const { history } = this.props;

    if (prevState.search !== this.state.search) {
      history.push("/Search/1");
      this.fetch_data(1);

      localStorage.setItem("search", this.state.search);
      localStorage.setItem("page", this.state.page);
      Object.keys(this.state.filter).forEach((element) => {
        localStorage.setItem(element, this.state.filter[element]);
      });
    }
  }

  Filter_Update(filter) {
    const { history } = this.props;

    this.setState({ filter: filter });
    history.push("/Search/1");
    this.fetch_data(1);

    localStorage.setItem("search", this.state.search);
    localStorage.setItem("page", this.state.page);
    Object.keys(this.state.filter).forEach((element) => {
      localStorage.setItem(element, this.state.filter[element]);
    });
  }

  render() {
    if (this.state.isLoading) {
      return <LoadingBar />;
    }

    const { history } = this.props;
    const fetched_models = this.state.fetched_models_array.map(
      (data, index) => {
        return <ModelBox key={index} data={data} history={history} />;
      }
    );

    const NaviButtonsWithRouter = withRouter(Navi_Buttons);

    return (
      <div style={{ width: "calc(100% - 8px)" }}>
        <Grid
          container
          style={{ marginTop: 10 }}
          spacing={1}
          justify="center"
          alignItems="flex-start"
        >
          <Grid item xs={3} md={3} container justify="center" spacing={1}>
            <Grid item xs={12} container justify="center">
              <Categories
                state={this.state}
                Filter_Update={this.Filter_Update.bind(this)}
              />
            </Grid>
            <Grid item xs={12} container justify="center">
              <Features
                state={this.state}
                Filter_Update={this.Filter_Update.bind(this)}
              />
            </Grid>
          </Grid>
          <Grid
            item
            xs={8}
            md={8}
            container
            justify="space-between"
            spacing={1}
          >
            <Grid
              item
              xs={12}
              md={6}
              container
              justify="space-between"
              alignItems="center"
            >
              <Grid item xs={12} md={6}>
                <SearchInput
                  value={
                    this.props.location.state
                      ? this.props.location.state.search
                      : localStorage.getItem("search")
                      ? localStorage.getItem("search")
                      : ""
                  }
                  UpdateSearchValue={(value) =>
                    this.setState({ search: value })
                  }
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                container
                justify="center"
                alignItems="center"
              >
                <Grid item>
                  <span>Aantal resultaten: {this.state.max}</span>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              container
              justify="center"
              alignItems="center"
            >
              <NaviButtonsWithRouter
                value={this.props.match.params.page}
                max={Math.ceil(this.state.max / this.state.filter.display)}
                Change_State={this.fetch_data.bind(this)}
              />
            </Grid>
            <Grid item xs={12} container spacing={1}>
              {fetched_models.length === 0 ? (
                <div>Geen resultaten gevonden...</div>
              ) : (
                fetched_models
              )}
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(Form_Modellen);
